import { ItemListOptionMetadata } from '@/contexts/item-context-types';
import { ItemsContext_VariantsPackFieldsFragment } from '@/types';
import { StyleSheet, View } from 'react-native';
import { SwapInboundItemSearchContent } from './swap-item-search-content';
import { VariantPackOrderCountsMap } from './types';

interface Props {
  alternativeMatches: ItemsContext_VariantsPackFieldsFragment[];
  initialRememberSelection: boolean;
  onClose: () => void;
  onSetRememberSelectionCallback: (nextValue: boolean) => void;
  onSwapItemCallback: (
    metadata: ItemListOptionMetadata,
    remember: boolean,
  ) => Promise<void>;
  previousMatches: ItemsContext_VariantsPackFieldsFragment[];
  savedVariantPackOrderCountsMap: VariantPackOrderCountsMap;
  substitutionsMatches: ItemsContext_VariantsPackFieldsFragment[];
  variantPackUUID: string;
}

export const SwapItemInlinePanel: React.FC<Props> = ({
  alternativeMatches,
  initialRememberSelection,
  onClose,
  onSetRememberSelectionCallback,
  onSwapItemCallback,
  previousMatches,
  savedVariantPackOrderCountsMap,
  substitutionsMatches,
  variantPackUUID,
}) => {
  return (
    <View
      style={styles.inlineSwapItemContainer}
      testID="swap-item-inline-panel"
    >
      <SwapInboundItemSearchContent
        alternativeMatches={alternativeMatches}
        initialRememberSelection={initialRememberSelection}
        onClose={onClose}
        onSetRememberSelection={onSetRememberSelectionCallback}
        onSwapItem={onSwapItemCallback}
        previousMatches={previousMatches}
        savedVariantPackOrderCountsMap={savedVariantPackOrderCountsMap}
        substitutionsMatches={substitutionsMatches}
        variantPackUUID={variantPackUUID}
      />
    </View>
  );
};

const styles = StyleSheet.create({
  inlineSwapItemContainer: {
    flex: 1,
  },
});
